import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import {
  clearDocumentTitleOverride,
  setDocumentTitleOverride,
} from '@/lib/pageTitle/documentTitle'

/**
 * Sets the browser tab title for the current page — the React equivalent of
 * Angular's `this.appService.title('Dashboard')`.
 *
 * Static titles already come from the route map in `@config/pageTitles`; use this
 * hook only for titles the page discovers at runtime (an email subject, a record
 * name). Pass `exact` to skip the `" | Liberty Rent"` suffix. A falsy title
 * leaves the route title in place, so it is safe to call while data is loading.
 */
export function usePageTitle(
  title: string | null | undefined,
  options?: { exact?: boolean },
) {
  const { pathname } = useLocation()
  const exact = options?.exact ?? false
  const resolved = title?.trim() ? title.trim() : null

  useEffect(() => {
    if (!resolved) return
    setDocumentTitleOverride(pathname, resolved, exact)
    return () => clearDocumentTitleOverride(pathname)
  }, [pathname, resolved, exact])
}
